

















































import {Component, Prop, Vue} from "vue-property-decorator";

import ProjectBreadcrumb from "@/views/components/projects/ProjectBreadcrumb.vue";
import {IProjectMetadata} from "@/interfaces/report";

import {projectStore, structureStore} from "@/store/store";

import NewAsphaltScenarioInfo from "@/modules/design/views/asphalt/1-AsphaltScenarioInfo.vue";
import NewAsphaltDesignParameters from "@/modules/design/views/asphalt/2-AsphaltDesignParameters.vue";
import {UnitSystem} from "@/interfaces/units";
import ErrorDisplay from "@/views/components/projects/ErrorDisplay.vue";
import {clearAllHttpErrors} from "@/lib/util/errors";


Component.registerHooks([
  "beforeRouteEnter",
]);

@Component({
  components: {
    ErrorDisplay,
    ProjectBreadcrumb,
    ScenarioInfo: NewAsphaltScenarioInfo,
    DesignParameters: NewAsphaltDesignParameters,
  },
})
export default class PavementStructureScenarioContainer extends Vue {
  @Prop() pages!: { link: string, text: string }[];

  @Prop() id!: number;

  get scenario() {
    const x = structureStore.currentScenario;
    return x;
  }

  projectMetadata: IProjectMetadata | null = null;

  created() {
    clearAllHttpErrors();
    structureStore.loadCurrentScenario(this.id).then((scenario: any) => {
      // const scenario = this.scenario;
      structureStore.setDisplayUnits(scenario.displayUnits);
      console.log("structure scenario", scenario);
      projectStore.getProjectMetadata(projectStore.currentProjectId).then((meta) => {
        this.projectMetadata = meta;
      });
    });
  }

  get currentUnitSystemIsImperial() {
    return structureStore.displayUnits === UnitSystem.Imperial;
  }

  saveUnitSelection() {
    if (this.currentUnitSystemIsImperial) {
      structureStore.setDisplayUnits(UnitSystem.Metric);
    } else {
      structureStore.setDisplayUnits(UnitSystem.Imperial);
    }
  }
}
